module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[17]260.c5217a6.woff2";